import type { TravelerDetailsQueryPaymentMethodPriceType } from '../common/types/queries/getSelectedTripOnTravelerDetailsPageQuery/models';

export const transformPaymentMethod = (method?: TravelerDetailsQueryPaymentMethodPriceType) => ({
  ...method,
  serviceFee:
    method &&
    'serviceFee' in method &&
    method.serviceFee &&
    typeof method.serviceFee === 'object' &&
    'value' in method.serviceFee
      ? method?.serviceFee?.value
      : null,
  price: method?.price?.value ?? 0,
});
